import { Component, Input } from '@angular/core';

@Component({
    selector: 'ec-charge-session-status-slide-power',
    templateUrl: './charge-session-status-slide-power.component.html',
    styleUrls: ['./charge-session-status-slide-power.component.scss'],
    standalone: false
})
export class ChargeSessionStatusSlidePowerComponent {
  @Input() powerValue: number;

  constructor() {}
}
